import { Stack } from 'expo-router';
import React from 'react';

import { GuideMessagingPage } from '../../../guide-messaging/components/GuideMessagingPage';

export default function GuideMessagingIndexPage() {
    return (
        <>
            <Stack.Screen
                options={{
                    title: 'Guide Messaging',
                }}
            />
            <GuideMessagingPage />
        </>
    );
}
